import ProductImage from '@assets/png/product.png';
import { PossibleTagsVal } from '@components/TagDialog/TagDialog.utils';
import { TagDialogHover } from '@components/TagDialog/TagDialogHover';
import { IEquipmentWithoutProduct } from '@models/Equipment.model';
import { IFieldConfiguration } from '@models/FieldConfiguration.model';
import { IEquipmentInventory } from '@models/EquipmentInventory.model';
import { TagsListInventory } from '@pages/Products/components/ListProducts/TagsList';
import { getEquipmentValue } from '@utils';
import { useHistory } from 'react-router-dom';
import {
  Image,
  Label,
  SelectedDiv,
  TagsWrapper,
  Td,
  Tr,
} from './ListEquipmentsTag.styles';

interface ItemComponentProps {
  // Making it optional here is Same as making it false.
  isSelected?: boolean;
  // Assume "first" is this equipment
  first?: boolean;
  widthResult: number;

  itemArrayPaginated?: IEquipmentInventory;
  item?: IEquipmentWithoutProduct;
  configuration: IFieldConfiguration[];
  onClose: () => void;
}
export function ItemComponent({
  isSelected = false,
  item,
  first = false,
  widthResult,
  configuration,
  itemArrayPaginated,
  onClose,
}: ItemComponentProps): JSX.Element {
  const history = useHistory();
  let tags: PossibleTagsVal = [];
  if (item) {
    tags = item.tags;
  }
  if (itemArrayPaginated) {
    tags = itemArrayPaginated.tags;
  }

  let itemId: string;
  if (item) {
    itemId = item.id;
  }
  if (itemArrayPaginated) {
    itemId = itemArrayPaginated.id;
  }
  return (
    <Tr
      isSelected={isSelected}
      key={JSON.stringify(item)}
      onClick={() => {
        // Assuming "first" is this equuipment
        if (!first) {
          history.push(`/equipments/${itemId}`);
          onClose();
        }
      }}
      first={first}
    >
      {configuration.map((headerItem, index) => {
        let value: string | undefined;
        let valueImgUrl: string | undefined | null;
        if (item) {
          value = getEquipmentValue(headerItem, item);
          valueImgUrl = item?.product?.imageUrl;
        }
        if (itemArrayPaginated) {
          value = getEquipmentValue(headerItem, itemArrayPaginated);
          valueImgUrl = itemArrayPaginated?.product?.imageUrl;
        }

        if (index === 0) {
          const add = headerItem?.fieldName === 'productName' ? 6 : 2;
          return (
            <Td widthPercentage={widthResult + add} isSelected={isSelected}>
              <Label>
                {valueImgUrl ? (
                  <Image src={valueImgUrl} alt="" />
                ) : (
                  <Image src={ProductImage} alt="" />
                )}
                {value}
              </Label>
            </Td>
          );
        }

        return (
          <Td widthPercentage={widthResult} isSelected={isSelected}>
            {value}
          </Td>
        );
      })}
      <Td widthPercentage={28} isSelected={isSelected}>
        <TagDialogHover tags={tags}>
          <TagsWrapper>
            <TagsListInventory tags={tags} />
          </TagsWrapper>
        </TagDialogHover>
      </Td>
      <SelectedDiv first={first}>This Asset</SelectedDiv>
    </Tr>
  );
}
